<template>
  <!-- :style="{height: controllerListHeight + 'px'}" -->
  <div class="controller-list scrollbar" @click="closeHandle">

    <div v-for="item in joinedList" :key="item.uid" class="controller-content">
      <div class="controller-left">
        <div class="controller-avatar">
          <img v-if="item.type == 1" :src="require('@/svg/chatavatar_7.svg')" />
          <img v-if="item.type == 2" :src="require('@/svg/chatavatar_8.svg')" />
          <img v-if="item.type == 3" :src="require('@/svg/chatavatar_6.svg')" />
          <div class="controller-auth" v-if="item.avctl == 1">
            <span>{{ $t("controller.主控") }}</span>
            <img width="30" :src="require('@/svg/controller.svg')" />
          </div>
          <div class="controller-auth" v-if="item.avctl != 1 && item.share == 1">
            <span style="bottom: -2px">{{ $t("controller.演示") }}</span>
            <img width="30" :src="require('@/svg/viewer.svg')" />
          </div>
        </div>
        <div>
          <h4>
            <!--            <el-tooltip-->
            <!--              class="item"-->
            <!--              effect="dark"-->
            <!--              :content="item.name"-->
            <!--              placement="top"-->
            <!--              :visible-arrow="false"-->
            <!--            >-->
            <!--              -->
            <!--            </el-tooltip>-->
            <span class="truncated-text" :data-tips="item.name">
              {{ item.name }}
            </span>
            <span v-if="userInfo.uid == item.uid">（{{ $t("onlineuser.我") }}）</span>
          </h4>
          <p class="controleer-role">
            <span v-if="item.type == 3">{{ $t("onlineuser.主播") }}
              <span v-if="hostUsersDuration">（{{ item.OnlineTime }}）</span></span>
            <span v-if="item.type == 2">{{ $t("onlineuser.助手")
            }}<span v-if="hostUsersDuration">（{{ item.OnlineTime }}）</span></span>
            <span v-if="item.type == 1">{{ $t("onlineuser.嘉宾")
            }}<span v-if="hostUsersDuration">（{{ item.OnlineTime }}）</span></span>
          </p>
        </div>
      </div>
      <div class="controller-right">
        <div class="pointer" v-if="item.type != 2" @click.stop="handelDevice(item, 'video')">
          <img  :class="{
            noDevice: !item.mediaStatus || !item.mediaStatus.video,
            deviceClose: item.mediaStatus && item.mediaStatus.video == 'inactive',
          }" :src="isShowCamera(item.mediaStatus)" />
        </div>
        <div class="pointer" v-if="item.type != 2" @click.stop="handelDevice(item, 'audio')">
          <img :src="require('@/svg/mic_main2.svg')" v-if="liveConfig?.liveondemandVoiceStatus === 0 && (mediaStatus == 2 || mediaStatus == 3)" />
          <template  v-else-if="item.mediaStatus && item.mediaStatus.audio && item.mediaStatus.audio == 'active'">
            <volume v-if="item.uid == userInfo.uid" :volume="inputInstant"></volume>
            <volume v-else :volume="item.AudioInputPercent"></volume>
          </template>
          <img v-else :src="isShowMic(item.mediaStatus)" :class="{
            noDevice: !item.mediaStatus || !item.mediaStatus.audio,
            deviceClose: item.mediaStatus && item.mediaStatus.audio == 'inactive',
          }" />
          <!-- </el-tooltip> -->
        </div>
        <div>
          <el-dropdown :hide-on-click="false" :disabled="!dropdownDisabled(item)" @command="userAction">
            <div class="pointer" style="line-height: 1; width: 20px">
              <img class="more_icon" :src="require('@/svg/more.svg')" v-if="!(item.type == 3 && role !== 3)" />
            </div>
            <el-dropdown-menu slot="dropdown" class="dropdown-dark">
              <el-dropdown-item v-if="role === 3 && item.type == 1" :command="{ action: 'giveUpHost', item }">{{
                $t("controller.设置为主播") }}</el-dropdown-item>
              <el-dropdown-item v-if="avctl == 1 && item.type == 2"
                :command="{ action: 'transferAuth', item, value: 1 }">{{ $t("controller.授予主控权") }}</el-dropdown-item>
              <el-dropdown-item v-if="avctl == 1 && (item.type == 1 || item.type == 2) && item.share == 0"
                :command="{ action: 'transferAuth', item, value: 0 }">{{ $t("controller.授予演示权") }}</el-dropdown-item>
              <el-dropdown-item v-if="avctl == 1 && item.share == 1 && item.uid != userInfo.uid"
                :command="{ action: 'takebackShowAuth', item }">{{ $t("controller.收回演示权") }}</el-dropdown-item>
              <el-dropdown-item v-if="
                (loginInfo &&
                  loginInfo.type != 13 &&
                  !disposableToken &&
                  item.uid == userInfo.uid) ||
                (role == 3 && item.type == 1)
              " :command="{ action: 'selfNickname', item }">{{ $t("controller.修改昵称") }}</el-dropdown-item>

              <el-dropdown-item v-if="role == 3 && item.type != 2 && item.uid != userInfo.uid"
                :command="{ action: 'lookDevice', item }">{{ $t("controller.查看设备") }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <device :visible.sync="openDevice" :deviceInfo="deviceInfo"></device>
    <Nickname :visible.sync="openNickname" />
    <UpHost :visible.sync="openUpHost" />
  </div>
</template>

<script>
import {
  tackBackShow,
  giveupMainControl,
  tackBackShowControl,
  getUserTime,
  giveUpHost,
} from "@/api/liveRequest/userApi";
import device from "../device";
import Bus from "@/components/doc/bus";
import { downSortcompare } from "@/utils/global";
import { Dropdown, DropdownItem, DropdownMenu, MessageBox } from "element-ui";
// import Bus from '@/components/doc/bus'
import Nickname from "./nickname.vue";
import UpHost from '@/components/upHost/upHost.vue';
import { getParameter } from "../../../utils/global";
import { mapGetters } from 'vuex';
import volume from '@/components/onLineUserList/volumeList.vue'
export default {
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    device,
    Nickname,
    UpHost,
    volume
  },
  props: {
    controllerListHeight: {
      type: Number,
    },
  },
  data() {
    return {
      openDevice: false,
      deviceInfo: null,
      curHadel: null,
      listHeight: 0,
      curJoinedLength: 0,
      joinedList: [],
      userIds: null,
      openNickname: false,
      openUpHost: false,
      loginInfo: null,
      giveUpHostShow: false,
      disposableToken: getParameter("disposableToken"),
      nickNameData: null,
    };
  },
  computed: {
    ...mapGetters(['mediaStatus','liveConfig','inputInstant']),
    dropdownDisabled() {
      const { role, avctl, userInfo, loginInfo, disposableToken } = this;
      return (item) => {
        const setHost = role === 3 && item.type == 1;
        const setAvclt = avctl == 1 && item.type == 2;
        const setShare =
          avctl == 1 && (item.type == 1 || item.type == 2) && item.share == 0;
        const getShare = avctl == 1 && item.share == 1 && item.uid != userInfo.uid;
        const setNickname =
          (loginInfo &&
            loginInfo.type != 13 &&
            !disposableToken &&
            item.uid == userInfo.uid) ||
          (this.role == 3 && item.type == 1);
        const getDevice = role == 3 && item.type != 2 && item.uid != userInfo.uid;
        return setHost || setAvclt || setShare || getShare || setNickname || getDevice;
      };
    },
    getMinHeight() {
      return () => {
        return (
          Math.max(
            Math.min(50 * this.joinedList.length + 20, parseFloat(this.listHeight)),
            70
          ) + "px"
        );
      };
    },
    getJoinedList() {
      return (
        this.$store.getters.JoinedList &&
        this.$store.getters.JoinedList.filter((p) => {
          return p && p.type != undefined;
        })
      );
    },
    // joinedList () {
    //   console.log(this.$store.getters.JoinedList);
    //   if (!this.$store.getters.JoinedList) return;
    //   let joinedListInfo = this.$store.getters.JoinedList.filter((p) => {
    //     return p && p.type != undefined;
    //   });
    //   if (joinedListInfo) {
    //     for (let i = 0; i < joinedListInfo.length; i++) {
    //       if (joinedListInfo[i].type == 3) {
    //         //如果是主播排5
    //         joinedListInfo[i] = Object.assign(joinedListInfo[i], { sort: 5 });
    //       } else if (joinedListInfo[i].avctl == 1) {
    //         //如果有主控权排4
    //         joinedListInfo[i] = Object.assign(joinedListInfo[i], { sort: 4 });
    //       } else if (joinedListInfo[i].share == 1) {
    //         //如果有演示权排3
    //         joinedListInfo[i] = Object.assign(joinedListInfo[i], { sort: 3 });
    //       } else if (joinedListInfo[i].uid == this.userInfo.uid) {
    //         //如果是我排2
    //         joinedListInfo[i] = Object.assign(joinedListInfo[i], { sort: 2 });
    //       } else if (joinedListInfo[i].type == 1) {
    //         //嘉宾排1
    //         joinedListInfo[i] = Object.assign(joinedListInfo[i], { sort: 1 });
    //       } else {
    //         //其余排0
    //         joinedListInfo[i] = Object.assign(joinedListInfo[i], { sort: 0 });
    //       }
    //     }
    //   }
    //   console.log(joinedListInfo);
    //   return joinedListInfo.sort(downSortcompare("sort"));
    // },
    isShowMic() {
      return (mediaStatus) => {
        if (mediaStatus && mediaStatus.audio && mediaStatus.audio == "active") {
          return require("@/svg/mic_green.svg");
        } else if (mediaStatus && mediaStatus.audio && mediaStatus.audio == "inactive") {
          if (this.avctl === 0 && this.authAudio === 0) {
            return require("@/svg/mic_main2.svg");
          } else {
            return require("@/svg/mic_close.svg");
          }
        } else {
          return require("@/svg/mic_close2.svg");
        }
      };
    },
    isShowCamera() {
      return (mediaStatus) => {
        if (mediaStatus && mediaStatus.video == "active") {
          return require("@/svg/local_video.svg");
        } else if (mediaStatus && mediaStatus.video == "inactive") {
          if (this.avctl === 0 && this.authVideo === 0) {
            return require("@/svg/video_main2.svg");
          } else {
            return require("@/svg/local_video_close.svg");
          }
        } else {
          return require("@/svg/local_video_close2.svg");
        }
      };
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return (
        this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.type
      );
    },
    share() {
      //演示权： 1：有  0：无
      return (
        this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.share
      );
    },
    // 主控权   1：有  0：无
    avctl() {
      return (
        this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.avctl
      );
    },
    authAudio() {
      //0:主控模式 1：自由
      return (
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.audio
      );
    },
    authVideo() {
      //0:主控模式 1：自由
      return (
        this.$store.getters.meetStatusInfo.groupInfo &&
        this.$store.getters.meetStatusInfo.groupInfo.video
      );
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    audio() {
      return (
        this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.audio
      );
    },
    video() {
      return (
        this.$store.getters.selfParticipant && this.$store.getters.selfParticipant.video
      );
    },
    groupInfo() {
      return this.$store.getters.groupInfo;
    },
    hostUsersDuration() {
      return this.$store.getters.hostUsersDuration;
    },
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    },
  },
  watch: {
    role() {
      this.giveUpHostShow && MessageBox.close();
      this.giveUpHostShow = false;
      this.openUpHost = false;
    },
    getJoinedList: {
      handler(value) {
        if (value && value.length) {
          let userId = null,
            joinedListInfo = value;
          if (joinedListInfo) {
            for (let i = 0; i < joinedListInfo.length; i++) {
              let findUser = this.joinedList.find((info) => {
                return info.uid == joinedListInfo[i].uid;
              });
              if (findUser && !findUser.onlineTimeSum) {
                joinedListInfo[i] = Object.assign(joinedListInfo[i], {
                  onlineTimeSum: 0,
                  OnlineTime: 0,
                });
              } else if (findUser && findUser.onlineTimeSum) {
                joinedListInfo[i] = Object.assign(joinedListInfo[i], {
                  onlineTimeSum: findUser.onlineTimeSum,
                  OnlineTime: findUser.OnlineTime,
                });
              }
              userId = userId
                ? `${userId},${joinedListInfo[i].uid}`
                : joinedListInfo[i].uid;
              if (joinedListInfo[i].type == 3) {
                //如果是主播排5
                joinedListInfo[i] = Object.assign(joinedListInfo[i], {
                  sort: 5,
                });
              } else if (joinedListInfo[i].avctl == 1) {
                //如果有主控权排4
                joinedListInfo[i] = Object.assign(joinedListInfo[i], {
                  sort: 4,
                });
              } else if (joinedListInfo[i].share == 1) {
                //如果有演示权排3
                joinedListInfo[i] = Object.assign(joinedListInfo[i], {
                  sort: 3,
                });
              } else if (joinedListInfo[i].uid == this.userInfo.uid) {
                //如果是我排2
                joinedListInfo[i] = Object.assign(joinedListInfo[i], {
                  sort: 2,
                });
              } else if (joinedListInfo[i].type == 1) {
                //嘉宾排1
                joinedListInfo[i] = Object.assign(joinedListInfo[i], {
                  sort: 1,
                });
              } else {
                //其余排0
                joinedListInfo[i] = Object.assign(joinedListInfo[i], {
                  sort: 0,
                });
              }
            }
          }

          this.joinedList = joinedListInfo.sort(downSortcompare("sort"));
          if (this.curJoinedLength == value.length) return;
          if (this.liveToken) {
            setTimeout(() => {
              this.getUserOnlineTimeSum(userId);
            }, 500);
          }
          this.userIds = userId;
          this.curJoinedLength = joinedListInfo.length;
        }
      },
      deep: true,
      immediate: true,
    },
    liveToken: {
      handler(value) {
        if (value && this.userIds) {
          this.getUserOnlineTimeSum(this.userIds);
        }
      },
    },
    // inputInstant: {
    //   immediate: true,
    //   handler(val) {
    //     this.joinedList.forEach(item => {
    //       if (item.uid == this.userInfo.uid) {
    //         item.AudioInputPercent = val;
    //         this.$forceUpdate()
    //       }
    //     })
    //   }
    // }
  },
  mounted() {
    this.loginInfo = JSON.parse(sessionStorage.getItem("LoginInfo"));
    this.updateScrollHeight();
    window.addEventListener("resize", this.updateScrollHeight);
    Bus.$on("startUserTimer", () => {
      if (!this.hostUsersDuration || this.liveStartStatus != 2) return;
      if (this.joinedList) {
        for (let i = 0; i < this.joinedList.length; i++) {
          this.joinedList[i].onlineTimeSum = this.joinedList[i].onlineTimeSum + 1000;
          this.joinedList[i].OnlineTime = this.modifyUserTime(
            this.joinedList[i].onlineTimeSum
          );
        }
      }
      this.$forceUpdate();
    });
    Bus.$on("liveStart", () => {
      if (!this.hostUsersDuration) return;
      let userIds = null;
      for (let i = 0; i < this.joinedList.length; i++) {
        userIds = userIds
          ? `${userIds},${this.joinedList[i].uid}`
          : this.joinedList[i].uid;
      }
      this.getUserOnlineTimeSum(userIds);
    });
    Bus.$on("voiceStimulationChange", (data) => {
      this.voiceStimulationChange(data);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScrollHeight);
  },
  methods: {
    voiceStimulationChange(voiceStimulationData) {
      if (voiceStimulationData.data.length != 0) {
        let pIds = voiceStimulationData.data.map((item) => item.ptid);
        this.joinedList.forEach((info) => {
          if (!pIds.includes(info.ptid)) {
            info.AudioInputPercent = 0;
          }
        });
        voiceStimulationData.data.forEach((voiceInfo) => {
          var layoutInfoData = this.joinedList.find((layoutInfo) => layoutInfo.ptid == voiceInfo.ptid);
          if (layoutInfoData) {
            layoutInfoData.AudioInputPercent = voiceInfo.voiceNum;
          }
        });
      }
    },
    getItemVideoContent(status, type) {
      // 嘉宾身份，9:16模式下提示9:16视频无法开启摄像头
      if (
        type == 1 &&
        this.$store.state.liveInfo.liveConfig &&
        this.$store.state.liveInfo.liveConfig.video_source_ratio
      ) {
        return this.$t("video.videoSourceRatio");
      }
      if (!status) {
        return this.$t("controller.视频已关闭");
      } else {
        return status.video === "active"
          ? this.$t("controller.视频已开启")
          : this.$t("controller.视频已关闭");
      }
    },
    getItemAudioContent(status) {
      console.log("status", status);
      if (!status) {
        return this.$t("controller.麦克风已关闭");
      } else {
        return status.audio === "active"
          ? this.$t("controller.麦克风已开启")
          : this.$t("controller.麦克风已关闭");
      }
    },
    updateScrollHeight() {
      const boxHeight = document.querySelector(".chatAndUser-container").offsetHeight;
      this.listHeight = boxHeight - 48 - 66 - 60 + "px";
    },
    // 转移权限： 0：演示权  1:主控权
    transferAuth(type, item) {
      if (type == 0) {
        console.log(item, "演示权人信息");
        this.giveShowAuth(item);
      } else {
        giveupMainControl(this.liveId, item.uid, this.liveToken).then((res) => {
          if (res && res.code == 200) {
            this.$message.success(this.$t("controller.转移成功"));
          } else {
            this.$message.error(`${this.$t("controller.转移失败")}:${res.msg}`);
          }
          // item.delflag = false;
          this.curHadel = null;
        });
        console.log(item);
      }
    },
    /**
     * 授予演示权提示
     */
    giveShowAuth(item) {
      // this.$confirm(this.$t("controller.若原演示权人正在演示文档或共享桌面"), '', {
      //     confirmButtonText: this.$t("controller.继续"),
      //     cancelButtonText: this.$t("controller.取消")
      //   }).then(() => {
          this.toShow(item);
        // }).catch(() => {

        // });
    },
  toShow(item) {
      tackBackShow(this.liveId, item.uid, this.liveToken).then((res) => {
            if (res && res.code == 200) {
              this.$message.success(this.$t("controller.转移成功"));
            } else {
              this.$message.error(this.$t("controller.转移失败"));
            }
            // item.delflag = false;
            this.curHadel = null;
          });

  },
    closeHandle() {
      // let curOpenList = this.joinedList.find((info) => {
      //   return info.delflag;
      // });
      // if (curOpenList) {
      //   curOpenList.delflag = false;
      //
      // }
      console.log(this.joinedList,'joinedList')
      this.curHadel = null;
    },
    showControlList(item) {
      if (item.type == 3) return;
      this.closeHandle();
      console.log(item);
      // item.delflag = true;
      this.curHadel = item;
    },

    // 收回演示权
    takebackShowAuth() {
      this.$confirm(this.$t("controller.若原演示权人正在演示文档或共享桌面"), '', {
          confirmButtonText: this.$t("controller.继续"),
          cancelButtonText: this.$t("controller.取消")
        }).then(() => {
          this.tackBackControl();
        }).catch(() => {

        });
    },
    tackBackControl() {
      tackBackShowControl(this.liveId, this.liveToken).then((res) => {
        if (res && res.code == 200) {
          this.$message.success(this.$t("controller.收回成功"));
        } else {
          this.$message.error(`${this.$t("controller.收回失败")}:${res.msg}`);
        }
      });
    },
    handelDevice(item, type) {
      console.log(item, "controller item");
      const liveConfig = this.$store.state.liveInfo.liveConfig;
      const mediaStatus = this.$store.getters.mediaStatus;
      if (type == "audio" && liveConfig &&  liveConfig.liveondemandVoiceStatus === 0 &&  (mediaStatus == 2 || mediaStatus == 3) && (this.avctl == 1 || this.userInfo.uid == item.uid)) {
        this.$message.error(this.$t("lianmai.插播静音已开启，您暂时不能开关麦克风"));
        return;
      }
      let isAuth = false;
        // 2.0.10 允许嘉宾与主播关闭音视频设备
      if (type == "audio" && this.userInfo.uid == item.uid &&  (this.authAudio == 1 || item.mediaStatus.audio == "active")) {
        isAuth = true;
      }
      console.log(isAuth, "00000000");
      if (
        type == "video" &&
        this.userInfo.uid == item.uid &&
        // 2.0.10 允许嘉宾与主播关闭音视频设备
        (this.authVideo == 1 || item.mediaStatus.video == "active")
      ) {
        isAuth = true;
      }
      if (this.avctl == 1 || isAuth) {
        if (type == "video") {
          if (!item.mediaStatus || !item.mediaStatus.video) return;
          const status =
            item.mediaStatus.video && item.mediaStatus.video == "active"
              ? "inactive"
              : "active";
          this.rtcClient.RTCRoom.handleParticipantCamera(item.uid, item.cid, status).then(
            (res) => {
              console.log(res);
            }
          );
        } else {
          if (!item.mediaStatus || !item.mediaStatus.audio) return;
          const status =
            item.mediaStatus.audio && item.mediaStatus.audio == "active"
              ? "inactive"
              : "active";
          this.rtcClient.RTCRoom.muteParticipant(item.uid, item.cid, status).then(
            (res) => {
              if (this.userInfo.uid == item.uid) {
                this.$store.commit("SET_SELFAUDIOSTATUS", status);
              }
              console.log(res);
            }
          );
        }
      } else {
        if (this.userInfo.uid == item.uid ) {
          if (this.authVideo === 0 && type === 'video') {
            this.$message.error(this.$t('aheader.视频主控模式已开启，禁止打开摄像头'));
          }
          if (this.authAudio === 0 && type === 'audio') {
            this.$message.error(this.$t('aheader.音频主控模式已开启，禁止打开麦克风'));
          }
        }
      }
    },
    lookDevice(item) {
      this.deviceInfo = item;
      this.openDevice = true;
    },
    selfNickname(item) {
      this.openNickname = true;
      this.nickNameData = item;
      console.log(item, "selfNickname");
    },
    async giveUpHost(item) {
      this.giveUpHostShow = true;
      let message =
        this.$t("controller.您确定要将主播角色转移给") +
        "【" +
        item.name +
        "】" +
        this.$t("controller.吗");
      await MessageBox.alert(message, {
        showCancelButton: true,
        confirmButtonText: this.$t("controller.确定"),
        cancelButtonText: this.$t("controller.取消"),
        title: this.$t("controller.提示"),
        customClass: "tip-alert",
      });
      const { code, msg } = await giveUpHost(item.uid, this.liveToken);
      if (code === 200) {
        this.$message.success(
          this.$t("controller.主播角色已成功转移至") + "【" + item.name + "】"
        );
      } else {
        this.$message.error(msg);
      }
    },
    async beTheHost() {
      this.openUpHost = true;
    },
    userAction({ action, item, value }) {
      switch (action) {
        case "transferAuth":
          this.transferAuth(value, item);
          break;
        case "takebackShowAuth":
          this.takebackShowAuth(item);
          break;
        case "lookDevice":
          this.lookDevice(item);
          break;
        case "selfNickname": // 修改昵称
          this.selfNickname(item);
          break;
        case "giveUpHost":
          this.giveUpHost(item);
          break;
        case "beTheHost":
          this.beTheHost(item);
          break;
      }
    },
    getUserOnlineTimeSum(userIds) {
      if (!this.hostUsersDuration) return;
      getUserTime(this.liveId, { userIds, webcastId: this.liveId }, this.liveToken).then(
        (res) => {
          if (res.code == 200 && res.data) {
            for (let i = 0; i < res.data.length; i++) {
              let findUser = this.joinedList.find((user) => {
                return user.uid == res.data[i].userId;
              });
              if (findUser) {
                findUser.onlineTimeSum = res.data[i].onlineTimeSum;
                findUser.OnlineTime = this.modifyUserTime(res.data[i].onlineTimeSum);
              }
            }
          }
        }
      );
    },
    modifyUserTime(onlineTimeSum) {
      if (onlineTimeSum == 0) return 0;
      let minutes = parseInt(onlineTimeSum / 1000 / 60);
      let second = parseInt((onlineTimeSum / 1000) % 60);
      return minutes + this.$t("controller.分") + second + this.$t("controller.秒");
    },
  }
};
</script>
<style lang="scss" scoped>
.controller-list {
  overflow-y: auto;
  height: 100%;
  padding-left: 10px;

  .controller-content {
    // padding: 0 12px;
    // padding-left: 20px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .controller-left {
      display: flex;
      justify-content: space-between;
      color: $white-color;
      text-align: left;
      align-items: center;

      .controleer-role {
        color: $grey5-color;
        font-size: 12px;
      }

      .controller-avatar {
        margin-right: 15px;
        width: 30px;
        position: relative;
        height: 30px;
        border-radius: 50%;
        background: #d8e2f9;

        >img {
          position: absolute;
        }

        .controller-auth {
          span {
            position: absolute;
            bottom: -1px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            left: 0;
            z-index: 10;
            line-height: 1;
            transform: scale(calc(10 / 12));
          }

          img {
            position: absolute;
          }
        }
      }
    }

    .controller-right {
      height: 50px;
      line-height: 50px;

      >div {
        display: inline-block;
        margin-right: 10px;
        overflow: hidden;
        width: 20px;
        z-index: 0;
        position: relative;
        // img {
        //   filter: drop-shadow($bule-color 80px 0);
        //   -webkit-filter: drop-shadow($bule-color 80px 0);
        //   transform: translateX(-80px);
        // }
        // .noDevice {
        //   filter: drop-shadow(rgba(138, 143, 153, 0.4) 80px 0);
        //   -webkit-filter: drop-shadow(rgba(138, 143, 153, 0.4) 80px 0);
        //   // transform: translateX(0px);
        // }
        // .deviceClose {
        //   filter: drop-shadow($grey5-color 80px 0);
        //   -webkit-filter: drop-shadow($grey5-color 80px 0);
        // }
        // .more_icon {
        //   filter: drop-shadow($grey5-color 80px 0);
        //   -webkit-filter: drop-shadow($grey5-color 80px 0);
        // }
      }
    }

    .controller-more-list {
      top: 0px;
      right: 10px;
      position: absolute;
      background-color: #2d3052;
      width: 100px;
      border-radius: 4px;
      z-index: 1;
      top: 35px;

      li {
        height: 50px;
        line-height: 50px;
        color: #fff;
        text-align: center;
      }
    }
  }
}

.more_icon {
  user-select: none;
}
.truncated-text{
  max-width: 70px;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.truncated-text:hover:after {
  content: attr(data-tips); /* 显示提示文本 */
  background: rgba(0, 0, 0, 0.8); /* 背景透明 */
  color: #fff;
  position: absolute;
  top: 50%; /* 位于文本下方 */
  left: 40px;
  max-width: 200px; /* 最大宽度为200px */
  white-space: normal;
  padding: 10px;
  border-radius: 3px;
  z-index: 1;
  display: none;
}

.truncated-text:hover:after {
  display: block; /* 显示提示文本 */
}
::v-deep .el-message-box__title {
  color:#fff;
}

</style>
